/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React from "react";

import { renderErrorMsg } from "../../../assets/component/renderErrorMsg.js";
import RenderPaymentCode from "./RenderPaymentCode";
import ToggleSwitch from "../../../assets/component/ToggleSwitch/ToggleSwitch.js";
import { mapPaymentMethodDataStatus, mapPaymentMethodData } from "../../../assets/helper.js";
import UpgradeNoticeCard from "./UpgradeNoticeCard";

const paymentMethods = [
  {
    key: "bocpay",
    label: "BoC Pay",
  }
];

export function RenderBocPay(state, func, textObj) {
  if (!state || !func) return;

  const bocpayStatus = mapPaymentMethodDataStatus(state.organizationObj.paymentMethodCode, paymentMethods[0].key);
  const bocpayData = mapPaymentMethodData(state.organizationObj.paymentMethodCode, paymentMethods[0].key);
  const bocpayHasQRCode = Boolean(bocpayData.code);

  if (state.loading) {
    return (
      <div className="OrgInfo-emptyPage">
        <div className="OrgInfo-center">
          <div className="OrgInfo-btm-load"></div>
        </div>
      </div>
    );
  }

  const currentPlan = state.organizationObj.currentPlan
    ? state.organizationObj.currentPlan.toLowerCase()
    : "";
  const isPremiumPlan = currentPlan === "premium";

  return (
    <div className="RenderBocPay-container">
      {isPremiumPlan ? (
        <>
          <div className="RenderBocPay-verticalLayout">
            <div className="RenderBocPay-bocpayLogo" />
            <div className="RenderBocPay-qrCodeContainer">
              <RenderPaymentCode state={state} func={func} paymentMethod={paymentMethods[0]} />
            </div>
            <div className="RenderBocPay-toggleContainer">
              <ToggleSwitch
                checked={bocpayStatus.checked}
                onChange={(e) => func.handleUpdatePaymentStatus(e, paymentMethods[0].key)}
                disabled={!bocpayHasQRCode}
                disabledMessage={!bocpayHasQRCode ? "Please upload a QR code first" : ""}
              />
            </div>
          </div>

          {renderErrorMsg(state.errMsgInfo.submitErr.msg)}
        </>
      ) : (
        <UpgradeNoticeCard onUpgradeClick={func.redirectToOrgBilling} />
      )}
    </div>
  );
}
